import {combineReducers} from '@modifi/redux'

import navigationReducer from './navigation/reducer'
import routesReducer from './routes/reducer'

export default combineReducers({
  navigation: navigationReducer,
  routes: routesReducer,
})
